import { fromJS, Record } from 'immutable';
import { v4 } from 'uuid';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { DepositTypesEnum } from '../document-data.data';

export const DEPOSIT_SCHEMA = Object.freeze({
  ID: '',
  DUE_DATE: '', // i2g-timezoneless-date (yyyy-mm-dd)
  TYPE: DepositTypesEnum.percentage,
  FIXED_AMOUNT: null, // subunits
  PERCENTAGE: 0.0, // number with 2 decimals
});
export const RECORD = generateSchema(DEPOSIT_SCHEMA);
export const KEYS: any = generateKeys(DEPOSIT_SCHEMA);

export class Deposit extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    if (!props.get(KEYS.ID)) {
      props = props.set(KEYS.ID, v4());
    }

    super(props);
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get dueDate(): string {
    return this.get(KEYS.DUE_DATE);
  }

  get type(): DepositTypesEnum {
    return this.get(KEYS.TYPE);
  }

  get fixedAmount(): number {
    return this.get(KEYS.FIXED_AMOUNT);
  }

  get percentage(): number {
    return this.get(KEYS.PERCENTAGE);
  }

  isNonPercentageScreen(): boolean {
    return this.type === DepositTypesEnum.fixed_amount;
  }
}
